import React from "react";
import AutosizeTextarea from "../AutosizeTextarea";

const NotesEditor = ({ classNames, value, handleChange, onSave }) => {
  const [focused, setFocused] = React.useState(false);

  return (
    <div className={`${classNames}`}>
      <div>
        <header>Notes</header>
        <AutosizeTextarea
          name="notes"
          value={value}
          handleChange={handleChange}
          placeholder="Write your notes here..."
          setFocused={setFocused}
          initialRows={2}
        />
      </div>
      {focused && (
        <button data-button-type="outline" onClick={onSave}>
          <span>Save</span>
        </button>
      )}
    </div>
  );
};

export default NotesEditor;
